import stationPodcastEpisodeRouter from "@/routes/stationPodcastEpisodeRouter"
import { i18n } from "@/plugins/i18n"

export default [
  {
    path: "podcasts",
    component: () => import("@/views/Podcasts/Podcasts.vue"),
    children: [
      {
        path: "",
        name: "station.podcasts.list",
        component: () => import("@/views/Podcasts/PodcastList.vue"),
        meta: {
          pageTitle: i18n.t("route.page_title.account.station.podcasts.list"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: "create",
        component: () => import("@/views/Podcasts/PodcastAdd.vue"),
        name: "station.podcasts.create",
        props: true,
        meta: {
          pageTitle: i18n.t("route.page_title.account.station.podcasts.create"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: ":podcastKey",
        component: () => import("@/views/Podcasts/Podcast.vue"),
        name: "station.podcast",
        props: true,
        meta: {
          pageTitle: "Podcast info",
          parent: "stations",
          rule: "owner",
        },
        children: [
          {
            // the sections of the podcast settings; the first one keeps the name and the URL the page always had
            path: "settings",
            component: () => import("@/views/Podcasts/PodcastSettings.vue"),
            children: [
              {
                name: "station.podcast.settings",
                path: "",
                component: () => import("@/views/Podcasts/PodcastSettingsInfo.vue"),
                meta: {
                  pageTitle: i18n.t("podcasts.settings_title"),
                  parent: "stations",
                  rule: "owner",
                },
              },
              {
                name: "station.podcast.settings.access",
                path: "access",
                component: () => import("@/views/Podcasts/PodcastSettingsAccess.vue"),
                meta: {
                  pageTitle: i18n.t("podcasts.settings_access_title"),
                  parent: "stations",
                  rule: "owner",
                },
              },
            ],
          },
          ...stationPodcastEpisodeRouter,
        ],
      },
    ],
  },
]
